<template>
  <v-container fluid>
    <v-row class="flex-grow-1">
      <v-col cols="12">
        <v-card :loading="loading" variant="outlined">
          <v-toolbar color="primary" density="comfortable">
            <v-toolbar-title class="text-white">
              {{ title }}
            </v-toolbar-title>
            <v-spacer />
            <div class="d-flex ga-2">
              <v-tooltip location="left">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" @click="cancel">
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </template>
                Fermer
              </v-tooltip>
              <v-tooltip location="left">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" @click="download">
                    <v-icon>mdi-file-download-outline</v-icon>
                  </v-btn>
                </template>
                Télécharger
              </v-tooltip>
              <v-tooltip location="left">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" :disabled="isSaveBtnDisabled" @click="saveTaskList">
                    <v-icon>mdi-content-save-all</v-icon>
                  </v-btn>
                </template>
                Sauvegarder
              </v-tooltip>
              <v-tooltip location="left">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" :disabled="isCreateNewTaskBtnDisabled"
                    @click="createNewTask">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                Créer une activité
              </v-tooltip>
              <v-tooltip location="left">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" :disabled="isAssignNewTaskBtnDisabled"
                    @click="assignNewTask">
                    <v-icon>mdi-eye-plus</v-icon>
                  </v-btn>
                </template>
                Assigner une activité
              </v-tooltip>
            </div>
          </v-toolbar>

          <v-card-text>
            <v-form ref="taskListForm" v-model="taskListFormValid">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model="taskList.codeTournee" :rules="rules.required" label="Code tournée *" />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field type="date" v-model="taskList.dateDebut" :rules="rules.date" label="Début planifié *" />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field type="date" v-model="taskList.dateFin" :rules="rules.date" label="Fin planifiée *" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="4">
                  <v-autocomplete v-model="taskList.taskListStatus" :items="taskListStatuses" label="Status" />
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete label="Techniciens *" v-model="taskList.technicienIds" :items="technicians"
                    item-title="fullName" item-value="id" multiple :rules="technicianRequired" />
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete label="Véhicule" v-model="taskList.vehicleId" :items="vehicles" item-title="label"
                    item-value="id" />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="ma-0">
      <v-col cols="12" class="pa-0">
        <div class="master-detail-container">
          <!-- LEFT -->
          <div class="left-pane" :style="{ width: leftWidth + 'px' }">
            <v-card variant="outlined" class="pa-2 fill-height">
              <v-list density="compact" nav>
                <v-list-item v-for="(task, idx) in tasks" :key="task.id" class="mb-2 task-row"
                  :class="{ 'selected-task': selectedTask?.id === task.id }" @click="selectTask(task)">
                  <v-row class="ma-0 align-start">
                    <v-col cols="12" class="pa-0">
                      <div class="d-flex align-center">
                        <img :src="taskStatusIcon(task.taskStatus)" alt="Done" width="16" height="16"
                          class="me-2 task-status-icon" />

                        <v-btn variant="text" size="small" class="task-number pa-0" @click.stop="selectTask(task)">
                          {{ task.numeroDeContrat }}
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col cols="12" class="pa-0">
                      <div class="task-name-clamp">
                        {{ task.name || `Task ${idx + 1}` }}
                      </div>

                      <v-divider />
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card>
          </div>

          <!-- Divider / handle -->
          <div class="drag-handle" :class="{ dragging: isDragging }" @mousedown.prevent="startDrag"
            @touchstart.prevent="startDrag" :title="'Drag to resize sidebar'" aria-label="Resizable panel divider"
            aria-valuemin="minWidth" aria-valuemax="maxWidth" role="separator" tabindex="0" @keydown="handleKeyDown">
            <div class="drag-line"></div>
          </div>

          <!-- RIGHT -->
          <div class="right-pane">
            <task-form :task="selectedTask" @update:task="onTaskUpdated" @delete:task="onTaskDeleted"
              @status-changed="onSelectedTaskStatusChanged" @name-changed="onSelectedTaskNameChanged" />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-dialog :scrim="true" v-model="confirmRemainingDialog" max-width="600" persistent>
      <v-card>
        <v-card-title class="text-h6"> Confirmation </v-card-title>

        <v-card-text style="white-space: pre-line">
          {{ confirmRemainingText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn variant="text" color="grey-darken-1" @click="confirmRemainingUndoneTaskNo">
            Annuler
          </v-btn>

          <v-btn variant="text" color="primary" @click="confirmRemainingUndoneTaskYes">
            Continuer et enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Assign New Task Dialog -->
    <div class="d-flex justify-center">
      <v-dialog :scrim="true" v-model="assignNewTaskModal" width="1000" persistent @keydown.esc="cancelAssignNewTask">
        <v-card>
          <v-card-title>{{ assignModelTitle }}</v-card-title>

          <v-card-text>{{ assignModalText }}</v-card-text>

          <v-card-text class="pb-0">
            <v-text-field v-model="assignTaskSearch" label="Rechercher" prepend-inner-icon="mdi-magnify" clearable
              density="compact" variant="outlined" hide-details />
          </v-card-text>

          <v-list v-model:selected="selectedTasks" select-strategy="leaf">
            <v-list-item v-for="item in filteredTasksEnAttente" :key="item.id" :value="item">
              <template #prepend="{ isSelected, select }">
                <v-checkbox :model-value="isSelected" @update:model-value="select" hide-details
                  color="deep-purple accent-4" />
              </template>

              <v-list-item-title>
                {{ taskLabel(item) }}
              </v-list-item-title>
            </v-list-item>
          </v-list>

          <v-card-actions>
            <v-spacer />

            <v-btn variant="text" color="blue-darken-1" @click="saveAssignedTasks">
              Confirmer
            </v-btn>

            <v-btn variant="text" color="red-darken-1" @click="cancelAssignNewTask">
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, toRaw } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAppStore } from "@/store/app";
import { TaskListStatus, TaskStatus, Vehicle } from "@/types";
import { Subtask } from "@/types";
import { Task } from "@/types";
import { TaskList } from "@/types";
import { User } from "@/types";
import TaskForm from "./TaskForm.vue";
import {
  getTaskListById,
  getTaskListGenById,
  postTaskList,
  putTaskList,
} from "@/utils/tasklist-api";
import { getFilteredTasks, getTasksByTaskListId, putTask } from "@/utils/task-api";
import { getAllTechnicians } from "@/utils/user-api";
import assignedIcon from "@/assets/icons/assigned_task.svg";
import doneIcon from "@/assets/icons/done_task.svg";
import inProgressIcon from "@/assets/icons/in_progress_task.svg";
import pendingIcon from "@/assets/icons/pending_task.svg";
import { createAndSaveDocument } from "@/utils/docx-util";
import { getAllVehicles } from "@/utils/vehicle-api";

interface Undone {
  type: string;
  id: string;
  title: string;
}

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();

const minWidth = 200;
const maxWidth = 800;
const isDragging = ref(false);
let startX = 0;
let startWidth = 240;

const createEmptyTaskList = (): TaskList => ({
  codeTournee: "",
  dateDebut: new Date(),
  dateFin: new Date(),
  technicienIds: [],
  technicienNames: [],
  taskListStatus: TaskListStatus.A_FAIRE,
  label: "",
  endAddress: {
    street: "",
    city: "",
    number: "",
    postcode: "",
  },
  startAddress: {
    numero: "",
    rue: "",
    codepostale: "",
    ville: "",
  },
});

const title = ref("");
const loading = ref(false);
const taskListFormValid = ref(false);
const taskListForm = ref();
const taskList = ref<TaskList>(createEmptyTaskList());
const tasks = ref<Task[]>([]);
const selectedTasks = ref<Task[]>([]);
const selectedTask = ref<Task | null>(null);
const technicians = ref<User[]>([]);
const vehicles = ref<Vehicle[]>([]);
const tasksEnAttente = ref<Task[]>([]);

const leftWidth = ref(240);
const confirmRemainingDialog = ref(false);
const assignNewTaskModal = ref(false);
const assignTaskSearch = ref("");
const assignModelTitle = "Ajouter une activité";
const assignModalText = "Sélectionnez une activité à ajouter à la tournée.";
const confirmRemainingText = ref(
  "Certaines tâches ou sous-tâches restent incomplètes. Voulez-vous continuer et enregistrer quand même "
);
const rules = {
  required: [(v: any) => !!v || "Champ obligatoire"],
  date: [(v: string) => !!v || "Date obligatoire"],
};

const taskListStatuses = Object.values(TaskListStatus);

const confirmRemainingResolve = ref<((val: boolean) => void) | null>(null);

const technicianRequired = computed(() => [
  (v: any[]) =>
    taskList.value.taskListStatus === TaskListStatus.EN_COURS && (!v || v.length === 0)
      ? "Au moins un technicien requis"
      : true,
]);

const filteredTasksEnAttente = computed(() => {
  const q = assignTaskSearch.value?.trim().toLowerCase();
  if (!q) return tasksEnAttente.value;
  return tasksEnAttente.value.filter((t) => taskLabel(t).toLowerCase().includes(q));
});

const isSaveBtnDisabled = computed(() => !taskListFormValid.value);
const isCreateNewTaskBtnDisabled = computed(() => tasks.value.some((t) => !t.id));
const isAssignNewTaskBtnDisabled = computed(() => !taskList.value.id);

const confirmRemainingUndoneTaskYes = () => {
  confirmRemainingDialog.value = false;
  confirmRemainingResolve.value?.(true);
  confirmRemainingResolve.value = null;
};

const confirmRemainingUndoneTaskNo = () => {
  confirmRemainingDialog.value = false;
  confirmRemainingResolve.value?.(false);
  confirmRemainingResolve.value = null;
};

function cancel() {
  router.push({ name: "tasklists" });
}

async function download() {
  const taskListGen = await getTaskListGenById(taskList.value.id);
  createAndSaveDocument(taskListFileName(), taskListTemplatePath(), taskListGen);
}

function taskListFileName(): string {
  return "PLANING_TECHNICIEN_TOURNEE_".concat(taskList.value.codeTournee);
}

function taskListTemplatePath(): string {
  return "../templates/TourneeTechnicienTemplate.docx";
}

function createNewTask() {
  const newTask = { name: "Nouvelle activité", taskListId: taskList.value.id, subtasks: [] } as Task;
  tasks.value.push(newTask);
  selectTask(newTask);
}

function assignNewTask() {
  assignNewTaskModal.value = true;
}

function cancelAssignNewTask() {
  assignNewTaskModal.value = false;
  assignTaskSearch.value = "";
}

async function saveAssignedTasks() {
  cancelAssignNewTask();
  if (!selectedTasks.value.length) {
    return;
  }

  selectedTasks.value.forEach((task) => (task.taskListId = taskList.value.id));
  await saveAndReloadTasks(selectedTasks.value);
  selectedTasks.value = [];
}

async function saveAndReloadTasks(_tasks: Task[]) {
  await Promise.all(_tasks.map((_task) => putTask(_task)));
  tasks.value = await getTasksByTaskListId(taskList.value.id);
}

function selectTask(task: Task) {
  selectedTask.value = task;
}

function onTaskUpdated(task: Task) {
  const idx = tasks.value.findIndex((t) => t.id === task.id);
  idx !== -1 ? (tasks.value[idx] = task) : tasks.value.splice(-1, 1, task);
  if (selectedTask.value?.id === task.id) {
    selectedTask.value = toRaw(task);
  }
}

function onTaskDeleted(task: Task) {
  tasks.value = tasks.value.filter((t) => t.id !== task.id);
  selectedTask.value = tasks.value[0] || null;
}

function onSelectedTaskStatusChanged(status: TaskStatus) {
  if (selectedTask.value) {
    selectedTask.value.taskStatus = status;
  }
}

function onSelectedTaskNameChanged(name: string) {
  if (selectedTask.value) {
    selectedTask.value.name = name;
  }
}

function taskStatusIcon(status: TaskStatus) {
  const map: Record<TaskStatus, string> = {
    [TaskStatus.A_FAIRE]: pendingIcon,
    [TaskStatus.ASSIGNE]: assignedIcon,
    [TaskStatus.EN_COURS]: inProgressIcon,
    [TaskStatus.FAITE]: inProgressIcon,
    [TaskStatus.NON_FAITE]: inProgressIcon,
    [TaskStatus.A_REPROGRAMMER]: inProgressIcon,
    [TaskStatus.APPROUVE]: doneIcon,
  };
  return map[status] || pendingIcon;
}

async function saveTaskList() {
  const form = taskListForm.value;
  if (!(await form.validate())) return;

  if (taskList.value.taskListStatus === TaskListStatus.APPROUVE) {
    // Check whether any task or subtask in the taskList remains undone
    const remainingUndone = retrieveUndone();
    // If there are any remaining undone items, ask confirmation
    if (remainingUndone.length > 0) {
      // Build a friendly message (first few entries)
      const preview = remainingUndone
        .slice(0, 5)
        .map((x) => `- ${x.title}`)
        .join("\n");
      const msg =
        `Certaines activités/tâches restent incomplètes (${remainingUndone.length}).\n` +
        `Exemples:\n${preview}\n\nVoulez-vous continuer et enregistrer quand même ?`;

      const confirmed = await openConfirmRemainingUndoneTask(msg);
      if (!confirmed) {
        return;
      }
    }
  }
  doSaveTaskList();
}

async function doSaveTaskList() {
  try {
    loading.value = true;
    if (!taskList.value.id) {
      taskList.value = await postTaskList(taskList.value);
      router.replace({
        name: "tasklist",
        params: { id: taskList.value.id },
      });
      title.value = "Editer la tournée";
      appStore.sendSuccessNotice("Une nouvelle tournée a été ajoutée");
    } else {
      console.log("Updating task list:", taskList.value);
      await putTaskList(taskList.value);
      appStore.sendSuccessNotice("La tournée a été mise à jour");
    }
    tasks.value = await getTasksByTaskListId(taskList.value.id);
    if (selectedTask.value) {
      selectedTask.value = tasks.value.find((t) => t.id === selectedTask.value.id);
    }
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    loading.value = false;
  }
}

function retrieveUndone(): Undone[] {
  const remainingUndone: Undone[] = [];
  for (const task of tasks.value) {
    if (task.taskStatus !== TaskStatus.APPROUVE) {
      remainingUndone.push({
        type: "task",
        id: task.id,
        title: taskLabel(task),
      });
    }

    for (const st of task.subtasks) {
      if (!st.done) {
        remainingUndone.push({
          type: "subtask",
          id: st.id,
          title: subTaskLabel(st),
        });
      }
    }
  }
  return remainingUndone;
}

function taskLabel(task: Task) {
  const laverieNumeroDeContrat = task.numeroDeContrat || "Inconnue";
  const tskType = task.taskType || "Inconnue";
  const lavName = task.name || "Inconnue";
  const tskStatus = task.taskStatus || "Inconnue";
  return (
    tskType +
    " (" +
    tskStatus +
    ") => Laverie " +
    lavName +
    " (" +
    laverieNumeroDeContrat +
    ")"
  );
}

function taskTooltip(task: Task) {
  const subject = task.subject || "Sans sujet";
  const observation = task.observation || undefined;
  return subject.concat(observation ? " (" + observation + ")" : "");
}

function subTaskLabel(subtask: Subtask) {
  return "Tâche " + subtask.name;
}

function openConfirmRemainingUndoneTask(message?: string): Promise<boolean> {
  if (message) {
    confirmRemainingText.value = message;
  }
  confirmRemainingDialog.value = true;
  return new Promise<boolean>((resolve) => {
    confirmRemainingResolve.value = resolve;
  });
}

function startDrag(event: MouseEvent | TouchEvent) {
  isDragging.value = true;

  const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;

  startX = clientX;
  startWidth = leftWidth.value;

  document.addEventListener("mousemove", handleDrag);
  document.addEventListener("touchmove", handleDrag, { passive: false });
  document.addEventListener("mouseup", stopDrag);
  document.addEventListener("touchend", stopDrag);

  document.body.classList.add("no-select-drag");
  document.body.style.cursor = "col-resize";
}

function handleDrag(event: MouseEvent | TouchEvent) {
  if (!isDragging.value) return;

  event.preventDefault();

  const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;

  const deltaX = clientX - startX;

  leftWidth.value = Math.max(minWidth, Math.min(maxWidth, startWidth + deltaX));
}

function stopDrag() {
  isDragging.value = false;

  document.removeEventListener("mousemove", handleDrag);
  document.removeEventListener("touchmove", handleDrag);
  document.removeEventListener("mouseup", stopDrag);
  document.removeEventListener("touchend", stopDrag);

  document.body.classList.remove("no-select-drag");
  document.body.style.cursor = "";

  saveWidth(leftWidth.value);
}

function handleKeyDown(event: KeyboardEvent) {
  const step = event.shiftKey ? 20 : 10;

  if (event.key === "ArrowLeft") {
    leftWidth.value = Math.max(minWidth, leftWidth.value - step);
  } else if (event.key === "ArrowRight") {
    leftWidth.value = Math.min(maxWidth, leftWidth.value + step);
  }
}

function loadSavedWidth() {
  const savedWidth = localStorage.getItem("sidebar-width");
  if (savedWidth) {
    const width = parseInt(savedWidth, 10);
    leftWidth.value = Math.max(200, Math.min(800, width));
  }
}

function saveWidth(width: number) {
  localStorage.setItem("sidebar-width", width.toString());
}

onMounted(async () => {
  const [allTechnicians, allVehicles] = await Promise.all([
    getAllTechnicians(),
    getAllVehicles(),
  ]);

  technicians.value = allTechnicians;
  vehicles.value = allVehicles;

  if (!route.params.id) {
    title.value = "Nouvelle tournée";
    return;
  }

  title.value = "Editer la tournée";

  taskList.value = await getTaskListById(route.params.id as string);
  tasks.value = await getTasksByTaskListId(taskList.value.id);

  tasksEnAttente.value = await getFilteredTasks([TaskStatus.A_FAIRE], []);

  selectedTask.value = tasks.value[0] ?? null;

  loadSavedWidth();
});

onUnmounted(() => {
  stopDrag();
});
</script>
<style scoped>
.selected-task {
  background-color: rgba(97, 92, 92, 0.25);
  border-radius: 6px;
}

.task-row {
  cursor: pointer;
}

.master-detail-container {
  display: flex;
  height: 100%;
  min-height: 300px;
  width: 100%;
}

.left-pane {
  overflow-y: auto;
  box-sizing: border-box;
  padding-right: 8px;
  padding-top: 10px;
  transition: width 0.1s ease-out;
}

.right-pane {
  height: 100%;
  overflow: hidden;
  padding-top: 10px;
  display: flex;
  flex: 1;
}

.dragging~.left-pane,
.dragging~.right-pane {
  transition: none !important;
}

.drag-handle {
  width: 16px;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  transition: background-color 0.2s;
  z-index: 10;
}

.drag-handle:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.drag-handle:active {
  background-color: rgba(0, 0, 0, 0.1);
}

.drag-handle .drag-line {
  width: 3px;
  height: 96%;
  background: var(--v-theme-on-surface, rgba(0, 0, 0, 0.12));
  border-radius: 3px;
  transition: background-color 0.2s, transform 0.2s;
}

.drag-handle:hover .drag-line {
  background: var(--v-theme-primary, #1976d2);
  transform: scaleX(1.5);
}

.dragging .drag-line {
  background: var(--v-theme-primary, #1976d2) !important;
  transform: scaleX(2) !important;
}

.no-select-drag {
  user-select: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  cursor: col-resize !important;
}

@media (hover: none) and (pointer: coarse) {
  .drag-handle {
    width: 24px;
    min-height: 44px;
  }

  .drag-handle .drag-line {
    width: 4px;
  }
}

.task-row img {
  display: block;
}

.task-status-icon {
  margin-top: -3px;
}

.task-number {
  text-transform: none;
  font-weight: 500;
  padding: 0 2px;
  min-width: 28px;
  font-size: 16px;
  color: #1976d2 !important;

  &:hover::before {
    opacity: 0 !important;
  }
}

.task-name-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2em;
  max-height: 1.2em;
  white-space: normal;
  word-wrap: break-word;
}

.left-pane .v-card.fill-height {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.task-row:hover {
  background: rgba(0, 0, 0, 0.02);
}

.mt-2 {
  margin: 4px 0 0 0;
}
</style>
